import { Page, Pages } from 'src/constants/Page';

export function isPaymentLinkPage(page?: Page): boolean {
    return page === Pages.PAYMENT_LINK_PAGE;
}
